import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../../../components/auth/login/login.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { Subscription } from 'rxjs';
import { SignUpComponent } from 'src/app/components/auth/sign-up/sign-up.component';
import { ForgotPasswordComponent } from 'src/app/components/auth/forgot-reset-password/forgot-reset-password.component';
import { HEADER_MENUS } from '../config/header-menu.data';
import { MaintenanceComponent } from 'src/app/components/all-modals/maintenance/maintenance.component';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss']
})
export class LandingHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  modalSubscription: Subscription;
  searchFlag = false;
  generalModal;
  size;
  centered;
  type;
  password;
  paramID;
  searchWord: string = '';
  isToggle = false;
  menuClicked = false;
  menus = []; redirect_url;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {
    this.modalSubscription = this.authService.modalGet().subscribe(item => {
      this.openModal(item);
    });
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.redirect_url) {
        this.redirect_url = params.redirect_url;
      }
    });
  }

  ngOnInit() {
    this.menus = HEADER_MENUS;
    if (this.router.url === '/search') {
      this.searchFlag = true;
    } else {
      this.searchFlag = false;
    }
  }
  ngAfterViewInit(): void {
    window.addEventListener('resize', this.onResizeScreen.bind(this));
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  navigateToLogin(){
    const modalRef = this.modalService.open(MaintenanceComponent, { centered: true });
  }

  toggleMenu() {
    this.isToggle = !this.isToggle;
    this.menuClicked = true;
    setTimeout(() => {
      this.menuClicked = false;
    }, 500);
  }

  onResizeScreen(e) {
    this.menus.forEach(m => m.isExpanded = false);
  }

  onScroll(e) {
    if (!this.menuClicked) {
      this.isToggle = false;
    }
  }

  search() {
    this.searchFlag = true;
  }

  openLoginModal() {
    const modalRef = this.modalService.open(LoginComponent, { size: 'lg', centered: true, ariaLabelledBy: 'loginModalCenterTitle' });
  }
  openSignUpModal() {
    this.authService.modalOpen('SignUpComponent', 'lg', true);
  }
  openModal(item) {
    switch (item.componentModal) {
      case 'SignUpComponent':
        this.generalModal = SignUpComponent;
        this.size = item.size;
        this.centered = item.center;
        break;

      case 'ForgotPasswordComponent':
        this.generalModal = ForgotPasswordComponent;
        this.size = item.size;
        this.centered = item.center;
        this.type = (item.type == 'reset' ? item.type : 'forgot');
        this.password = item.token;
        this.paramID = item.paramID;
        break;

      default:
        break;
    }
    const modalRef = this.modalService.open(this.generalModal, { size: this.size, centered: this.centered });

    if (this.type !== undefined)
      modalRef.componentInstance.modalType = this.type;

    if (this.password !== undefined)
      modalRef.componentInstance.reset_token = this.password;

    if (this.paramID !== undefined)
      modalRef.componentInstance.paramID = this.paramID;

  }
  goToSearch() {
    this.searchFlag = true;
  }

  searchData(event) {

    if (event.keyCode === 13) {
      this.router.navigate(['/search'], { queryParams: { searchQuery: this.searchWord } });
    }
  }

  hideInput() {
    if (this.searchWord) {
      this.searchFlag = false;
    }
    else this.searchFlag = false;
  }

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

}
